const GOOGLE_MAPS_SCRIPT_ID = "pdx-google-maps-js-api";

let googleMapsLoadPromise = null;

async function resolveGoogleMapsNamespace() {
  if (!window.google?.maps) {
    throw new Error("Google Maps loaded without the Maps namespace.");
  }

  if (typeof window.google.maps.importLibrary === "function") {
    await window.google.maps.importLibrary("marker");
  }

  return window.google.maps;
}

export function loadGoogleMapsApi(apiKey) {
  if (
    !apiKey ||
    typeof window === "undefined" ||
    typeof document === "undefined"
  ) {
    return Promise.resolve(null);
  }

  if (window.google?.maps) {
    return resolveGoogleMapsNamespace();
  }

  if (googleMapsLoadPromise) {
    return googleMapsLoadPromise;
  }

  googleMapsLoadPromise = new Promise((resolve, reject) => {
    let script = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);

    const cleanup = () => {
      script?.removeEventListener("load", handleLoad);
      script?.removeEventListener("error", handleError);
    };

    const handleLoad = async () => {
      cleanup();

      try {
        const googleMaps = await resolveGoogleMapsNamespace();
        resolve(googleMaps);
      } catch (error) {
        googleMapsLoadPromise = null;
        reject(
          error instanceof Error
            ? error
            : new Error("Google Maps loaded without the Maps namespace."),
        );
      }
    };

    const handleError = () => {
      cleanup();
      googleMapsLoadPromise = null;
      reject(new Error("Failed to load the Google Maps JavaScript API."));
    };

    if (!script) {
      script = document.createElement("script");
      script.id = GOOGLE_MAPS_SCRIPT_ID;
      script.async = true;
      script.defer = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        apiKey,
      )}&libraries=marker&v=weekly`;
      document.head.appendChild(script);
    }

    script.addEventListener("load", handleLoad);
    script.addEventListener("error", handleError);
  });

  return googleMapsLoadPromise;
}
